import {createAction} from 'redux-actions'

export const clear = createAction('REMOTE_INSPECTIONS/RESULTS/CLEAR')
export const update = createAction('REMOTE_INSPECTIONS/RESULTS/UPDATE')
export const markAsViewed = createAction('REMOTE_INSPECTIONS/RESULTS/MARK_AS_VIEWED',
    resultIds => Array.isArray(resultIds) ? resultIds : [resultIds],
)
export const sendEmail = createAction('REMOTE_INSPECTIONS/RESULTS/SEND_EMAIL',
    resultIds => Array.isArray(resultIds) ? resultIds : [resultIds],
)